// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionTwoProduct {
  background: linear-gradient(to bottom, rgba(157, 170, 241, 0.32) 0%, rgba(157, 170, 241, 0.32) 66%, #ec6927 66%, #ec6927 100%) !important;
  min-height: 100vh !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 300px 180px 150px;
}
.sectionTwoProduct #ProductSectionTwo-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 50px;
  color: #1c2640;
}
.sectionTwoProduct #ProductSectionTwo-subHead {
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 2%;
  color: #52667c;
}
.sectionTwoProduct #ProductSectionTwo-card {
  min-height: 376px;
  width: 100%;
  grid-gap: 5%;
  gap: 4%;
  background-color: white;
  border-radius: 10px;
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease 0s;
  cursor: pointer;
}
.sectionTwoProduct #ProductSectionTwo-card:hover {
  transform: scale(1.05);
}
.sectionTwoProduct #ProductSectionTwo-card-1 {
  width: 28%;
  height: 300px;
  border-right: 2px solid rgba(51, 51, 51, 0.5);
}
.sectionTwoProduct #ProductSectionTwo-card-2 {
  width: 30%;
  height: 300px;
  border-right: 2px solid rgba(51, 51, 51, 0.5);
}
.sectionTwoProduct #ProductSectionTwo-card-3 {
  width: 26%;
  height: 300px;
}
.sectionTwoProduct #ProductSectionTwo-card-1-icon,
.sectionTwoProduct #ProductSectionTwo-card-2-icon,
.sectionTwoProduct #ProductSectionTwo-card-3-icon {
  width: 20%;
}
.sectionTwoProduct #ProductSectionTwo-card-1-head1,
.sectionTwoProduct #ProductSectionTwo-card-2-head1,
.sectionTwoProduct #ProductSectionTwo-card-3-head1 {
  color: #6a6a6a;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  margin-top: 4%;
}
.sectionTwoProduct #ProductSectionTwo-card-1-head2,
.sectionTwoProduct #ProductSectionTwo-card-2-head2,
.sectionTwoProduct #ProductSectionTwo-card-3-head2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 20px;
  /* or 62% */
  text-transform: capitalize;
  color: #ec6927;
  margin-top: 2%;
}
.sectionTwoProduct #ProductSectionTwo-card-1-para,
.sectionTwoProduct #ProductSectionTwo-card-2-para,
.sectionTwoProduct #ProductSectionTwo-card-3-para {
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #52667c;
  margin-top: 35px;
  margin-right: 10%;
}
.sectionTwoProduct #ProductSectionTwo-ctas {
  margin-top: 2%;
  /* margin-bottom: 2%; */
  width: 90%;
  gap: 5%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/SectionTwo/sectionTwo.scss"],"names":[],"mappings":"AAAA;EACC,yIAAA;EAOA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;AALD;AAOC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALF;AAQC;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AANF;AASC;EACC,iBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;AAPF;AASE;EAEC,sBAAA;AAPH;AAWC;EACC,UAAA;EACA,aAAA;EACA,6CAAA;AATF;AAWC;EACC,UAAA;EACA,aAAA;EACA,6CAAA;AATF;AAWC;EACC,UAAA;EACA,aAAA;AATF;AAYC;;;EAGC,UAAA;AAVF;AAaC;;;EAGC,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXF;AAcC;;;EAGC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EAEA,0BAAA;EAEA,cAAA;EAEA,cAAA;AAfF;AAkBC;;;EAGC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAhBF;AAmBC;EACC,cAAA;EACA,uBAAA;EACA,UAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF","sourcesContent":[".sectionTwoProduct {\n\tbackground: linear-gradient(\n\t\tto bottom,\n\t\trgba(#9daaf1, 0.32) 0%,\n\t\trgba(#9daaf1, 0.32) 66%,\n\t\t#ec6927 66%,\n\t\t#ec6927 100%\n\t) !important;\n\tmin-height: 100vh !important;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 300px 180px 150px;\n\n\t#ProductSectionTwo-head {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 43px;\n\t\tline-height: 50px;\n\t\tcolor: #1c2640;\n\t}\n\n\t#ProductSectionTwo-subHead {\n\t\tfont-family: Roboto;\n\t\tfont-size: 18px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tmargin-top: 2%;\n\t\tcolor: #52667c;\n\t}\n\n\t#ProductSectionTwo-card {\n\t\tmin-height: 376px;\n\t\twidth: 100%;\n\t\tgrid-gap: 5%;\n\t\tgap: 4%;\n\t\tbackground-color: white;\n\t\tborder-radius: 10px;\n\t\tmargin-top: 5%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttransition: all 0.3s ease 0s;\n\t\tcursor: pointer;\n\n\t\t&:hover{\n\t    \t-webkit-transform: scale(1.05);\n\t\t\ttransform: scale(1.05);\n\t    }\n\t}\n\n\t#ProductSectionTwo-card-1 {\n\t\twidth: 28%;\n\t\theight: 300px;\n\t\tborder-right: 2px solid rgba(51, 51, 51, 0.5);\n\t}\n\t#ProductSectionTwo-card-2 {\n\t\twidth: 30%;\n\t\theight: 300px;\n\t\tborder-right: 2px solid rgba(51, 51, 51, 0.5);\n\t}\n\t#ProductSectionTwo-card-3 {\n\t\twidth: 26%;\n\t\theight: 300px;\n\t}\n\n\t#ProductSectionTwo-card-1-icon,\n\t#ProductSectionTwo-card-2-icon,\n\t#ProductSectionTwo-card-3-icon {\n\t\twidth: 20%;\n\t}\n\n\t#ProductSectionTwo-card-1-head1,\n\t#ProductSectionTwo-card-2-head1,\n\t#ProductSectionTwo-card-3-head1 {\n\t\tcolor: #6a6a6a;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tfont-size: 18px;\n\t\tline-height: 20px;\n\t\tmargin-top: 4%;\n\t}\n\n\t#ProductSectionTwo-card-1-head2,\n\t#ProductSectionTwo-card-2-head2,\n\t#ProductSectionTwo-card-3-head2 {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tfont-size: 30px;\n\t\tline-height: 20px;\n\t\t/* or 62% */\n\n\t\ttext-transform: capitalize;\n\n\t\tcolor: #ec6927;\n\n\t\tmargin-top: 2%;\n\t}\n\n\t#ProductSectionTwo-card-1-para,\n\t#ProductSectionTwo-card-2-para,\n\t#ProductSectionTwo-card-3-para {\n\t\tfont-family: Roboto;\n\t\tfont-size: 16px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 21px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #52667c;\n\t\tmargin-top: 35px;\n\t\tmargin-right: 10%;\n\t}\n\n\t#ProductSectionTwo-ctas {\n\t\tmargin-top: 2%;\n\t\t/* margin-bottom: 2%; */\n\t\twidth: 90%;\n\t\tgap: 5%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
